// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"0869e1166b8a98ddc6d9","231":"a49114412341b9af42c2","610":"6df212b29d2fe1c50e36","691":"05951a0169c1d84a045a","711":"4bf908b08887911a8e31"}[chunkId] + ".js";
};